module.exports = __webpack_public_path__ + "img/pro.ff4041b8.svg";